export const { ACCESS_TOKENS = [], ALL_ACCESS_TOKENS = {} } = window || {}

export const {
  STAFF: {
    TYPES: { IS_COORDINATOR, IS_DOCTOR, IS_CLIENT, IS_ADMINISTRATOR },
  },
} = ALL_ACCESS_TOKENS
